// frontend/src/components/ReorderModal.js

import React, { useState, useEffect } from "react";
import * as api from "../api";
// AFTER (Correct)
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

function ReorderModal({ isOpen, onClose, onSave, collectionId }) {
  const [pdfs, setPdfs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  console.log("ReorderModal recebeu o ID:", collectionId);

  useEffect(() => {
    // Busca os PDFs quando o modal é aberto
    if (isOpen && collectionId) {
      const fetchPdfsForReorder = async () => {
        console.log("Iniciando busca de PDFs para a coleção:", collectionId);
        setIsLoading(true);
        try {
          const response = await api.getCollectionPdfs(collectionId);
          // Ordena os PDFs com base na ordem salva, se existir
          const sortedPdfs =
            response.data.pdf_order.length > 0
              ? response.data.pdfs.sort(
                  (a, b) =>
                    response.data.pdf_order.indexOf(a.filename) -
                    response.data.pdf_order.indexOf(b.filename)
                )
              : response.data.pdfs;
          setPdfs(sortedPdfs);
        } catch (error) {
          console.error("Erro ao buscar PDFs para reordenar", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchPdfsForReorder();
    }
  }, [isOpen, collectionId]);

  const handleDragEnd = (result) => {
    if (!result.destination) return; // Sai se o item for solto fora da lista

    const items = Array.from(pdfs);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setPdfs(items);
  };

  const handleSave = () => {
    const ordered_filenames = pdfs.map((pdf) => pdf.filename);
    onSave(collectionId, ordered_filenames);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
        <h3 className="text-2xl font-bold mb-6 text-gray-900 flex-shrink-0">
          Reordenar PDFs
        </h3>

        {isLoading ? (
          <p>A carregar...</p>
        ) : (
          <div className="overflow-y-auto flex-grow min-h-0 pr-4">
            <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="pdfs">
              {(provided) => (
                <ul
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="space-y-2"
                >
                  {pdfs.map((pdf, index) => (
                    <Draggable
                      key={pdf.filename}
                      draggableId={pdf.filename}
                      index={index}
                    >
                      {(provided) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="p-3 bg-gray-100 rounded-md border text-gray-800 flex items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 mr-3 text-gray-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M5 12a1 1 0 102 0V8a1 1 0 10-2 0v4zm7 0a1 1 0 102 0V8a1 1 0 10-2 0v4zm-4 0a1 1 0 102 0V8a1 1 0 10-2 0v4z" />
                          </svg>
                          {pdf.filename}
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
            </DragDropContext>
          </div>
        )}

        <div className="mt-8 flex justify-end space-x-4 flex-shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-lg"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg"
          >
            Guardar Ordem
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReorderModal;
